<div class="container-lg mt-5 1-column">
  <div class="content-wrapper">
    <div class="content-header"></div>
    <div class="content-body">
      <section class="flexbox-container">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="col-md-8 col-10" style="margin-top: -1%">
            <div class="text-center mb-2">

            </div>
            <div class="slogan" style="padding-left: 26px">
              <p class="text-slogan text-voce">VOCÊ</p>
              <p class="text-slogan text-saudavel">SAUDÁVEL</p>
              <p class="text-slogan text-saudavel">E SEGURO</p>
              <p class="text-slogan text-voce">É A NOSSA</p>
              <p class="text-slogan text-meta">META.</p>
            </div>
            <div class="card border-grey form-radius border-lighten-3 px-1 py-1 m-0">
              <div class="card-header border-0">
                <div class="card-title text-center">
                  <img
                    style="cursor: pointer"
                    src="../../../../assets/app-assets/images/logo/logo-b-geia.png"
                    [routerLink]="'/home'"
                    width="100"
                    alt="geia logo" />
                </div>
                <div class="card-title text-center" *ngIf="isEmailConfirmado">
                  <img src="../../../../assets/app-assets/images/icons/gif-email.gif" width="100" alt="geia logo" />
                  <p style="font-size: 13px; font-weight: 600; color: #023341">
                    E-mail confirmado! Faça o login para acessar a ferramenta!
                  </p>
                </div>
              </div>

              <div class="card-content">
                <p class="card-subtitle text-muted text-center font-small-3 font-small-3-bold mx-2 my-1">
                  <span>Informe as suas credenciais para logar.</span>
                </p>
                <div class="card-body">
                  <form
                    *ngIf="!isLoggedIn"
                    name="form"
                    (ngSubmit)="(f.form.valid)"
                    #f="ngForm"
                    novalidate
                    class="form-horizontal">
                    <fieldset class="form-group position-relative has-icon-left">
                      <input
                        style="margin-top: -18px"
                        name="email"
                        [(ngModel)]="login.email"
                        required
                        #email="ngModel"
                        type="text"
                        class="form-control border-radius"
                        id="user-email"
                        placeholder="Informe o E-mail"
                        required />
                      <div class="form-control-position" style="margin-top: -21px">
                        <i class="fa fa-envelope-o"></i>
                      </div>
                      <div class="text-center text-sm-center" role="alert">
                        <label
                          *ngIf="email.errors && f.submitted"
                          class="font-alert text-center card-title danger"
                          for="inputSuccess">
                          <strong>E-mail obrigatório!</strong>
                        </label>
                      </div>
                      <div class="text-center text-sm-center" role="alert" *ngIf="f.submitted && isLoginFailed">
                        <label class="font-alert text-center card-title danger" for="inputSuccess">
                          <strong>{{ errorMessage }}</strong>
                        </label>
                      </div>
                    </fieldset>

                    <fieldset class="form-group position-relative has-icon-left">
                      <input
                        [type]="showPassword ? 'text' : 'password'"
                        name="password"
                        [(ngModel)]="login.password"
                        required
                        #password="ngModel"
                        minlength="6"
                        class="form-control border-radius"
                        id="user-password"
                        placeholder="Informe a senha"
                        required="true" />
                      <div class="form-control-position">
                        <i
                          class="pointer font-medium-3"
                          [ngClass]="{'ft-eye': showPassword, 'ft-eye-off': !showPassword}"
                          aria-hidden="true"
                          (click)="showHidePassword()"></i>
                      </div>
                      <div class="text-center text-sm-center" role="alert" *ngIf="password.errors && f.submitted">
                        <label
                          *ngIf="password.errors['required']"
                          class="font-alert text-center card-title danger"
                          for="inputSuccess">
                          <strong>A senha é obrigatória!</strong>
                        </label>
                      </div>
                      <div class="col-md-12 mb-1 col-sm-12">
                        <app-captcha #captcha (tokenChange)="captchaToken = $event"></app-captcha>
                      </div>
                    </fieldset>

                    <div class="form-group row"></div>

                    <button
                      [disabled]="!captchaToken"
                      (click)="onLogin()"
                      class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 mr-1 mb-1 btn-block">
                      <i class="ft-unlock"></i>
                      Login
                    </button>
                  </form>
                </div>
                <!-- <p class="card-subtitle border-radius   bold-azul text-muted text-center font-small-3 mx-2 my-1">
                     <span>Novo Usuário?</span>
                   </p>
                   <div class="card-body">
                     <button type="button" (click)="onRedirectCadastro()"
                       class="btn btn-round btn-outline-danger btn-geia-danger btn-min-width box-shadow-4 mr-1 mb-1 btn-block"><i
                         class="ft-user "></i>
                       Cadastrar</button>
                   </div> -->
                <div class="card-footer">
                  <div>
                    <p class="float-sm-left text-center m-0">
                      <a
                        href="javascript:void(0)"
                        class="underline font-color-geia pointer"
                        (click)="onRedirectEsqueceuSenha()">
                        Esqueceu a senha?
                      </a>
                    </p>

                    <p class="float-sm-right text-center m-0 underline">
                      <a
                        href="javascript:void(0)"
                        class="font-color-geia pointer underline"
                        (click)="onRedirectEsqueceuEmail()">
                        Esqueceu o E-mail?
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<ngx-spinner type="ball-newton-cradle" [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff">
  <p style="color: white">Carregando...</p>
</ngx-spinner>
